import { RadioButton, Typography } from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { Institution } from "../../../../models/Institution";
import { Request, EnrollmentDecision } from "../../../../models/Request";
import { generateApprovalText } from "../../utils/strings";

interface InstitutionApprovalRadioGroupProps {
  isEditing: boolean;
  isApproved: boolean;
  onApprovalChange: (isApproved: boolean) => void;
  primaryInstitution?: Institution;
  secondaryInstitution?: Institution;
  request: Request;
  enrollmentDecision?: EnrollmentDecision;
}

export function InstitutionApprovalRadioGroup({
  isEditing,
  isApproved,
  onApprovalChange,
  primaryInstitution,
  secondaryInstitution,
  request,
  enrollmentDecision,
}: InstitutionApprovalRadioGroupProps) {
  const { t } = useTranslation();

  if (!isEditing) {
    return (
      <Row>
        <Col md={12}>
          <Typography variant="baseBold">
            {t("suggestedOutsideEnrollmentArea.countyIsApproved")}:&nbsp;
            <b>{generateApprovalText(request, enrollmentDecision)}</b>
          </Typography>
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row>
        <Col md={12}>
          <Typography variant="baseBold">
            {t("suggestedOutsideEnrollmentArea.countyIsApproved")}:
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col md={2} />
        <Col md={10}>
          <RadioButton
            ariaLabel={t("common.no")}
            label={`${t(
              "suggestedOutsideEnrollmentArea.primaryInstitution"
            )}: ${primaryInstitution?.name}`}
            checked={!isApproved}
            name="no"
            onChange={() => onApprovalChange(false)}
            disabled={!isEditing}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} />
        <Col md={10}>
          <RadioButton
            ariaLabel={t("common.yes")}
            label={`${t(
              "suggestedOutsideEnrollmentArea.secondaryInstitution"
            )}: ${secondaryInstitution?.name}`}
            checked={isApproved}
            name="yes"
            onChange={() => onApprovalChange(true)}
            disabled={!isEditing}
          />
        </Col>
      </Row>
    </>
  );
}
